(() => {
  const money = (value) => {
    const amount = Number(value || 0);
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const fieldValue = (root, name) => {
    const input = root.querySelector('[name="' + name + '"]');
    return input ? input.value.trim() : '';
  };

  const checkoutParams = (root) => {
    const params = new URLSearchParams();
    const values = {
      email: fieldValue(root, 'email'),
      firstName: fieldValue(root, 'first_name'),
      lastName: fieldValue(root, 'last_name'),
      phone: fieldValue(root, 'phone'),
      address1: fieldValue(root, 'address1'),
      address2: fieldValue(root, 'address2'),
      zip: fieldValue(root, 'postal_code'),
      city: fieldValue(root, 'city')
    };

    if (values.email) params.set('checkout[email]', values.email);
    if (values.firstName) params.set('checkout[shipping_address][first_name]', values.firstName);
    if (values.lastName) params.set('checkout[shipping_address][last_name]', values.lastName);
    if (values.phone) params.set('checkout[shipping_address][phone]', values.phone);
    if (values.address1) params.set('checkout[shipping_address][address1]', values.address1);
    if (values.address2) params.set('checkout[shipping_address][address2]', values.address2);
    if (values.zip) params.set('checkout[shipping_address][zip]', values.zip);
    if (values.city) params.set('checkout[shipping_address][city]', values.city);
    params.set('checkout[shipping_address][country]', 'France');

    return params.toString();
  };

  const init = (root) => {
    document.body.classList.add('ac-precheckout-active');

    const packs = Array.from(root.querySelectorAll('[data-ac-pack]'));
    const toggle = root.querySelector('[data-ac-subscription-toggle]');
    const mainButton = root.querySelector('[data-ac-continue]');
    const addressButton = root.querySelector('[data-ac-address-continue]');
    const mobileButton = root.querySelector('[data-ac-mobile-continue]');
    const heroImage = root.querySelector('[data-ac-hero-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-ac-gallery-image]'));

    if (!packs.length || !toggle || !mainButton) return;

    const summaryPack = root.querySelector('[data-ac-summary-pack]');
    const summaryMeta = root.querySelector('[data-ac-summary-meta]');
    const summaryPrice = root.querySelector('[data-ac-summary-price]');
    const summaryTotal = root.querySelector('[data-ac-summary-total]');
    const summaryShipping = root.querySelector('[data-ac-summary-shipping]');
    const summaryImage = root.querySelector('[data-ac-summary-image]');
    const subTitle = root.querySelector('[data-ac-sub-title]');
    const subDescription = root.querySelector('[data-ac-sub-description]');
    const subCopy = root.querySelector('[data-ac-sub-copy]');
    const errorMessages = Array.from(root.querySelectorAll('[data-ac-error]'));
    const mobileLabel = root.querySelector('[data-ac-mobile-label]');
    const mobilePrice = root.querySelector('[data-ac-mobile-price]');

    let selectedPack = packs.find((button) => button.dataset.acPack === '3') || packs[0];
    let subscription = true;
    let busy = false;

    const setBusy = (state) => {
      busy = state;
      const label = state ? 'Préparation du paiement…' : 'Continuer vers le paiement sécurisé';
      [mainButton, addressButton].forEach((button) => {
        if (!button) return;
        button.setAttribute('aria-disabled', state ? 'true' : 'false');
        button.disabled = state;
        button.textContent = label;
      });
      if (mobileButton) {
        mobileButton.disabled = state;
        mobileButton.textContent = state ? 'Chargement…' : 'Continuer';
      }
    };

    const render = () => {
      packs.forEach((button) => {
        const active = button === selectedPack;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');

        const price = button.querySelector('[data-ac-card-price]');
        const compare = button.querySelector('[data-ac-compare-price]');
        const unit = button.querySelector('[data-ac-unit-price]');
        const amount = Number(subscription ? button.dataset.subscriptionPrice : button.dataset.onetimePrice);
        const oneTime = Number(button.dataset.onetimePrice || 0);
        const count = Math.max(1, Number(button.dataset.acPack || 1));

        if (price) price.textContent = money(amount);
        if (compare) {
          compare.hidden = !subscription;
          compare.textContent = subscription ? money(oneTime) : '';
        }
        if (unit) unit.textContent = money(amount / count) + ' / unité';
      });

      toggle.classList.toggle('is-on', subscription);
      toggle.setAttribute('aria-checked', subscription ? 'true' : 'false');

      const frequency = selectedPack.dataset.frequency || 'Chaque mois';

      if (subTitle) subTitle.textContent = subscription ? 'Abonnez-vous et économisez' : 'Achat unique';
      if (subDescription) {
        subDescription.textContent = subscription
          ? 'Recevez automatiquement votre produit au tarif abonné. Modifiez, mettez en pause ou annulez votre abonnement à tout moment.'
          : 'Vous commandez cette formule une seule fois, sans renouvellement automatique.';
      }
      if (subCopy) {
        subCopy.textContent = subscription
          ? '✓ Abonnement sélectionné · ' + frequency + ' · Décochez cette option si vous préférez un achat unique.'
          : '✓ Achat unique sélectionné · Aucun renouvellement automatique.';
      }

      const packCount = Number(selectedPack.dataset.acPack || 1);
      const packLabel = selectedPack.dataset.summaryLabel || selectedPack.dataset.packLabel;
      const amount = Number(subscription ? selectedPack.dataset.subscriptionPrice : selectedPack.dataset.onetimePrice);

      if (summaryPack) summaryPack.textContent = packLabel;
      if (summaryMeta) {
        summaryMeta.textContent = 'Quantité : ' + packCount + ' unité' + (packCount > 1 ? 's' : '') + ' · ' + (subscription ? 'Abonnement · ' + frequency : 'Achat unique');
      }
      if (summaryPrice) summaryPrice.textContent = money(amount);
      if (summaryTotal) summaryTotal.textContent = money(amount);
      if (summaryShipping) summaryShipping.hidden = Number(selectedPack.dataset.shippingFee || 0) <= 0;
      if (summaryImage) {
        summaryImage.src = selectedPack.dataset.image;
        summaryImage.alt = 'Alpha Brew — ' + packLabel;
      }

      if (mobileLabel) mobileLabel.textContent = packLabel + ' · ' + (subscription ? 'Abonnement · ' + frequency : 'Achat unique');
      if (mobilePrice) mobilePrice.textContent = money(amount);

      root.dataset.selectedVariant = selectedPack.dataset.variantId;
      root.dataset.selectedSellingPlan = subscription ? selectedPack.dataset.sellingPlanId : '';
      root.dataset.selectedMode = subscription ? 'subscription' : 'onetime';
      root.dataset.selectedPack = selectedPack.dataset.acPack;
      root.dataset.selectedPrice = String(amount);
    };

    packs.forEach((button) => {
      button.addEventListener('click', () => {
        if (busy) return;
        selectedPack = button;
        if (heroImage) heroImage.src = button.dataset.image;
        render();
      });
    });

    toggle.addEventListener('click', () => {
      if (busy) return;
      subscription = !subscription;
      render();
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!heroImage) return;
        heroImage.src = thumb.dataset.acGalleryImage;
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    const checkout = async () => {
      if (busy) return;

      errorMessages.forEach((node) => {
        node.hidden = true;
        node.textContent = '';
      });

      const variantId = Number(root.dataset.selectedVariant || 0);
      const sellingPlanId = Number(root.dataset.selectedSellingPlan || 0);

      if (!variantId || (subscription && !sellingPlanId)) {
        errorMessages.forEach((node) => {
          node.hidden = false;
          node.textContent = 'Impossible de préparer cette offre. Veuillez choisir un pack et réessayer.';
        });
        return;
      }

      setBusy(true);

      try {
        const clearResponse = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        });
        if (!clearResponse.ok) throw new Error('cart_clear_failed');

        const item = { id: variantId, quantity: 1 };
        if (subscription) item.selling_plan = sellingPlanId;

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [item] })
        });
        if (!addResponse.ok) throw new Error('cart_add_failed');

        const params = checkoutParams(root);
        window.location.assign('/checkout' + (params ? '?' + params : ''));
      } catch (error) {
        setBusy(false);
        errorMessages.forEach((node) => {
          node.hidden = false;
          node.textContent = 'Impossible de préparer le paiement. Veuillez réessayer dans quelques instants.';
        });
      }
    };

    mainButton.addEventListener('click', checkout);
    if (addressButton) addressButton.addEventListener('click', checkout);
    if (mobileButton) mobileButton.addEventListener('click', checkout);

    render();
  };

  const boot = () => document.querySelectorAll('[data-ac-precheckout]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();